import React, {useEffect, useState} from "react";
import {Stack, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import {BpCard} from "./BpCard";
import services from "../../services";
import {useParams} from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import {BpChart} from "../Charts/BpChart";

const data = ["#089BAB","#0867AB","#08AB7A"]

export interface bpReadings{
    name : string,
    min : number,
    max : number,
    color : string,
    state : string
}

const skelton = [1,2,3]

export const BpSection = () =>{

    const [bpReadings,setBpReadings] = useState<bpReadings[]>([])

    const [showSkelton,setShowSkelton] = useState<boolean>(false)

    return(
        <React.Fragment>
            <Grid container spacing={2}>
                {
                    showSkelton ?
                        skelton.map((e)=>(
                            <Grid item lg={2} md={4} key={e} >
                                <Stack
                                    sx={{background:"#383E3D3D",padding:"20px"}}
                                    direction="row" spacing={1} className="card-blood-pressure"  justifyContent="space-between">
                                    <Stack>
                                        <Skeleton variant="text" animation="wave" width={80} />
                                        <Skeleton variant="text" animation="wave" width={40}/>
                                    </Stack>
                                    <Stack>
                                        <Skeleton variant="text" animation="wave" width={70} />
                                        <Skeleton variant="text" animation="wave" width={50} />
                                    </Stack>
                                </Stack>
                            </Grid>
                        ))

                        :
                            bpReadings.map((e, index) => (
                                <BpCard key={index} color={e.color} name={e.name} max={e.max} min={e.min} state={e.state}/>
                            ))
                }
            </Grid>
        </React.Fragment>
    )
}